import React from 'react';
import { makeStyles } from '@fluentui/react-components';

export const useSpacerStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
});

export const Spacer: React.FC = () => {
  const classes = useSpacerStyles();

  return (
    <div className={classes.root} />
  );
};
